import React from 'react';
import { Button } from './ui/Button';
import { Card, CardContent } from './ui/Card';
import { Carousel, CarouselContent, CarouselItem } from './ui/Carousel';
import { eventsData } from '../data/eventsData';
export function EventsSection() {
  const events = eventsData.slice(0, 3);
  return <section id="evenements" className="bg-white py-[120px]" data-id="element-85">
      <div className="container mx-auto px-4 md:px-8" data-id="element-86">
        <div className="max-w-3xl mb-12" data-id="element-87">
          <h2 className="text-[36px] md:text-[48px] font-bold text-arih-dark leading-tight mb-4" data-id="element-88">
            Agenda des prochains événements à Agadir Souss Massa
          </h2>
          <p className="text-[18px] text-arih-gray leading-[28.8px] whitespace-pre-line" data-id="element-89">
            {"Ne manquez aucun rendez-vous ! Explorez les événements culturels,\nartistiques et professionnels qui animent Agadir Souss Massa tout au long de l'année."}
          </p>
        </div>

        <Carousel opts={{
        align: 'start',
        loop: true
      }} className="w-full mb-12" data-id="element-90">
          <CarouselContent className="-ml-4 md:-ml-6" data-id="element-91">
            {events.map((event, index) => <CarouselItem key={index} className="pl-4 md:pl-6 md:basis-1/3" data-id="element-92">
                <Card className="border-0 shadow-sm bg-white rounded-xl overflow-hidden h-full" data-id="element-93">
                  <CardContent className="p-0 flex flex-col h-full" data-id="element-94">
                    <img src={event.image} alt={event.title} className="w-full h-[220px] object-cover" data-id="element-95" />
                    <div className="p-6 flex-grow flex flex-col" data-id="element-96">
                      <h3 className="text-[20px] md:text-[24px] font-bold text-arih-dark mb-3 leading-tight" data-id="element-97">
                        {event.title}
                      </h3>
                      <p className="text-[16px] text-arih-gray font-medium mb-4" data-id="element-98">
                        {event.date}
                      </p>
                      <a href={`/evenements/${event.id}`} className="text-arih-blue text-[16px] font-semibold hover:underline inline-flex items-center mt-auto" data-id="element-99">
                        Voir plus <span className="ml-1" data-id="element-100">→</span>
                      </a>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        <div className="flex justify-center mt-8" data-id="element-101">
          <a href="/evenements" data-id="element-102">
            <Button className="bg-arih-blue text-white rounded-full px-[34px] py-[8px] h-auto text-[16px] font-semibold hover:bg-blue-800 transition-colors shadow-none border-0" data-id="element-103">
              Tous les événements
            </Button>
          </a>
        </div>
      </div>
    </section>;
}